<template>
  <div class="grid">
    <div class="col-5">
      <img :src="getCoverImage()" class="singleRecipe-img" />
    </div>
    <div class="col-1"></div>
    <div class="col-6">
      <h1 class="singleRecipe-title">{{ $t(singleRecipe.key) }}</h1>
      <div class="row-box">
        <!-- <p class="boxes">
          {{ singleRecipe.category.data.attributes.category }}
        </p> -->
        <p class="boxes">{{ singleRecipe.calories + " Kcal" }}</p>
      </div>
      <div class="summary">
        <img src="/assets/layout/images/single-recipe/Guanto.png" />
        <p>
          {{
            $t("singleRecipe.difficulty") + ": " + $t(singleRecipe.difficulty)
          }}
        </p>
      </div>
      <div class="summary">
        <img src="/assets/layout/images/single-recipe/Ora.png" />
        <p>
          {{
            $t("singleRecipe.preparation") +
              ": " +
              (singleRecipe.prep_time + singleRecipe.cooking_time) +
              " Min"
          }}
        </p>
      </div>
      <div class="summary">
        <img src="/assets/layout/images/single-recipe/Ingredienti.png" />
        <p>
          {{ $t("presentation.ingredients") }}
          <b>{{ singleRecipe.ingredients.length }}</b>
        </p>
      </div>
      <Button class="mr-4" @click="addToFavorite()">{{
        $t("singleRecipe.add_to_favorite")
      }}</Button>
      <Button>{{ $t("singleRecipe.share") }}</Button>
    </div>
  </div>
</template>

<script>
import {
  addToFavorite,
  getLikedRecipesbyUserWithLabels,
} from "../../service/UsersService";
export default {
  data() {
    return {
      liked_recipes: null,
    };
  },
  computed: {
    singleRecipe: function() {
      return this.$store.getters["recipes/getRecipe"];
    },
    user_id: function() {
      return this.$store.getters["profile/id"];
    },
    access_token: function() {
      return this.$store.getters["userdata/getAccessToken"];
    },
    locale: function() {
      return this.$store.getters["preferences/locale"];
    },
  },
  async mounted() {
    this.liked_recipes = await getLikedRecipesbyUserWithLabels(
      this.access_token,
      this.locale,
      this.user_id
    );
    this.liked_recipes = this.liked_recipes.liked_recipes.map(function(el) {
      return el.id;
    });
  },
  methods: {
    getCoverImage() {
      let cover = "";
      const regex = new RegExp(/_[0-9]*_[a-zA-Z0-9]*.png/);
      this.singleRecipe.media.data.forEach((element) => {
        if (!element.attributes.url.match(regex)) {
          cover = element.attributes.url;
        }
      });
      return cover;
    },
    addToFavorite() {
      this.liked_recipes.push(this.singleRecipe.id);
      this.liked_recipes = this.liked_recipes.filter((item, pos) => {
        return this.liked_recipes.indexOf(item) == pos;
      });
      addToFavorite(this.user_id, this.access_token, this.liked_recipes);
    },
  },
};
</script>

<style></style>
